import { configureStore } from '@reduxjs/toolkit'

import leaderBoardReducer from '../features/LeaderBoard/leaderBoardSlice'
import myProfileSliceReducer from '../features/MyProfile/myProfileSlice'
import seasonStatusSlice from '../features/SeasonStatus/seasonStatusSlice'

export const store = configureStore({
    reducer: {
        leaderBoard: leaderBoardReducer,
        profile: myProfileSliceReducer,
        seasonStatus: seasonStatusSlice,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
